// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2GWSv","form":"styles_form__3d1X2"};